var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"hpanel"},[_c('div',{staticClass:"panel-body",attrs:{"id":"html-2-pdfwrapper"}},[_c('biblio-tree',{attrs:{"nodes":_vm.nodes,"depth":0,"print":false,"parentCounter":0,"ref-depth":{}}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06bad994","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/biblio/BiblioPreview.vue
// module id = null
// module chunks = 